import { makeAutoObservable } from 'mobx';

const STORAGE_KEY = 'skvoz:onboarding:seen';

function readSeen(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function writeSeen(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* хранилище недоступно — не критично */
  }
}

export class OnboardingStore {
  isOpen = false;
  hasSeen: boolean = readSeen();

  constructor() {
    makeAutoObservable(this);
  }

  open() {
    this.isOpen = true;
  }

  openIfFirstVisit() {
    if (!this.hasSeen) {
      this.isOpen = true;
    }
  }

  close() {
    this.isOpen = false;
    if (!this.hasSeen) {
      this.hasSeen = true;
      writeSeen();
    }
  }

  reset() {
    this.hasSeen = false;
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
  }
}
